import type { CityConfig } from "../city-template/types";

export const gilletteConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Gillette",
  state: "Wyoming",
  stateAbbr: "WY",
  slug: "gillette",
  route: "/gillette",
  title: "Emergency Passport Gillette, WY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Gillette, WY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Gillette, Campbell County, Powder River Basin energy workers, and northeastern Wyoming travelers. No Denver trip needed.",
  h1: "Emergency & Expedited Passport Services in Gillette, WY",
  heroSubtitle: "Energy sector professional heading to a Middle East assignment? Campbell County family planning a Canadian Rockies vacation? Powder River Basin worker with an international rotation? We help Gillette residents — from coal and oil field professionals to ranch families to GCC students — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20Gillette%20Wyoming%20under%20the%20dramatic%20big%20sky%20of%20the%20Powder%20River%20Basin%2C%20with%20the%20distinctive%20Campbell%20County%20landscape%20of%20rolling%20prairie%20and%20distant%20mesas%20at%20golden%20hour%2C%20energy%20industry%20infrastructure%20subtle%20in%20the%20background%2C%20western%20frontier%20town%20atmosphere%2C%20crisp%20high-plains%20light%20with%20warm%20amber%20tones%2C%20editorial%20documentary%20photography%20style&width=1800&height=700&seq=gillette-hero-2026&orientation=landscape",
  heroImageAlt: "Gillette Wyoming in the Powder River Basin at golden hour with dramatic big sky",
  geoPosition: "44.2911;-105.5022",
  geoPlacename: "Gillette, Wyoming",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "Cherry Creek III, 3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Nearest regional passport agency — located approximately 380 miles from Gillette via I-90 and I-25; a 6+ hour drive one way",
  },
  nearbyCitiesZips: [
    { name: "Gillette", zips: "82716, 82718" },
    { name: "Wright", zips: "82732" },
    { name: "Moorcroft", zips: "82721" },
    { name: "Rozet", zips: "82727" },
    { name: "Recluse", zips: "82725" },
    { name: "Weston", zips: "82731" },
    { name: "Buffalo", zips: "82834" },
    { name: "Sundance", zips: "82729" },
  ],
  benefits: [
    { icon: "ri-oil-line", title: "Energy Sector International Travel Expertise", desc: "Campbell County produces nearly 40% of America's coal. Energy professionals frequently travel to international mining and energy conferences, equipment supplier meetings, and overseas project sites. We understand the short-notice travel demands of the Powder River Basin energy sector." },
    { icon: "ri-flight-takeoff-line", title: "GCC — Gillette Campbell County Airport", desc: "GCC connects to Denver International Airport via United Express. DIA is a major international gateway. We coordinate passport timelines around GCC connections to Denver and beyond." },
    { icon: "ri-building-2-line", title: "No Denver Trip Needed — 380 Miles Is Too Far", desc: "Denver Passport Agency is 380 miles from Gillette — a 6+ hour drive each way. For Campbell County energy workers, ranch families, and GCC students, our courier service eliminates that drive entirely." },
    { icon: "ri-home-2-line", title: "Boomtown Flexibility & Fast Turnaround", desc: "Gillette's energy-driven economy means opportunities surface quickly — international assignments, training rotations, and equipment site visits with short lead times. We match that pace with courier expedited service that gets passports done fast." },
  ],
  internalLinks: [
    { name: "Expedited passport in Casper, WY", route: "/casper" },
    { name: "Fast passport services in Sheridan, WY", route: "/sheridan-wy" },
    { name: "Quick passport in Rapid City, SD area", route: "/rapid-city" },
    { name: "Urgent passport services in Billings, MT", route: "/billings" },
    { name: "Wyoming passport services overview", route: "/states/wyoming" },
  ],
  fpcOfficeAddress: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
  fpcOfficeNote: "Fast Passport Center serves Gillette via secure registered courier with direct access to the Denver Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 6+ hours to Colorado. Gillette residents can ship from any UPS Store, FedEx Office, or post office location across Campbell County.",
  fpcOfficeDistance: "Serving Gillette, Wright, Moorcroft, Rozet, Recluse, Weston, and all Campbell County and northeastern Wyoming communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Gillette and Campbell County. From the energy sector offices along Highway 59 to the ranches of the Powder River Basin, from the GCC campus to the subdivisions of Antelope Valley — we serve all of northeastern Wyoming. Our courier service eliminates the need to drive 380 miles to Denver for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Gillette and all Campbell County communities including Wright, Moorcroft, Rozet, and Recluse. We also serve Powder River Basin energy workers, Campbell County ranch families, and GCC students planning international travel.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Gillette as simple as possible — with the speed and reliability Campbell County energy professionals, ranch families, and GCC students need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Gillette travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Gillette travelers encounter unique passport issues — from short-notice energy sector international assignments to Powder River Basin address verification to GCC study abroad documentation. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Northeastern Wyoming travelers — from Powder River Basin energy professionals to Campbell County ranch families to GCC students heading abroad — trust us when their international departure is days away and Denver is simply not an option.",
  faqIntro: "Have questions about expedited passports in Gillette, WY? Here are the most common ones we hear from Campbell County travelers.",
  statePageRoute: "/states/wyoming",
  statePageName: "Wyoming",
  servicesIntro: "Whether you need a renewal before an international energy conference, an emergency passport for a last-minute GCC connection to DIA, or a first-time passport for a Campbell County family vacation abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.dot.state.wy.us/driverservices",
  dmvLabel: "Wyoming Department of Transportation — Driver Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Denver trip needed — we handle everything remotely", "Ideal for energy sector international assignments", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with government shutdowns", "In-person clerk appointment required in Gillette", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Denver agency is 380 miles from Gillette", "6+ hour drive — completely impractical for Campbell County residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "GCC connection to DIA for an international energy conference in 2 days? Last-minute overseas assignment? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Gillette travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Gillette residents renew fast — no agency visit required for most renewals. Perfect for energy sector professionals and Campbell County families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Campbell County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed — so your international assignment or family vacation is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Campbell County family trip abroad stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for energy sector professionals with overlapping international assignments and business travel.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Campbell County travelers through the process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Gillette residents making quick trips to Canada.",
      bullets: ["Wallet-size convenience", "Land and sea crossings to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Gillette WY", description: "Urgent passport processing for Gillette Wyoming travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Gillette WY", description: "Fast passport renewal for Gillette Wyoming residents with a previously-issued passport." },
    { name: "First-Time Passport Gillette WY", description: "New passport application services for Gillette Wyoming residents applying for their first passport." },
    { name: "Child Passport Gillette WY", description: "Minor passport services for Gillette Wyoming families with children under 16." },
    { name: "Name Change Passport Gillette WY", description: "Passport name correction after marriage, divorce, or legal name changes for Gillette residents." },
    { name: "Second Passport Gillette WY", description: "Second passport services for Gillette frequent travelers and energy sector professionals." },
  ],
  testimonials: [
    {
      name: "Mike D.",
      location: "Gillette",
      rating: 5,
      text: "Got a 10-day notice for an energy conference in Dubai. My passport was expired and Denver was a 6-hour drive. Fast Passport Center got me a renewed passport in 4 days. Made the conference. Absolute game changer for Campbell County professionals.",
      service: "Passport Renewal",
    },
    {
      name: "The Reynolds Family",
      location: "Gillette",
      rating: 5,
      text: "We planned a Canadian Rockies family trip and our kids needed first passports. Fast Passport Center walked us through the whole process, caught a photo issue at the Gillette post office, and got all four passports back in time. Saved us from driving to Denver.",
      service: "Child Passports — Family",
    },
    {
      name: "Carla R.",
      location: "Wright",
      rating: 5,
      text: "Energy sector rotation to Australia — needed my passport renewed with only 3 weeks notice. Living in Wright, the idea of driving to Denver was a non-starter. Fast Passport Center handled everything remotely and I had my passport in 5 days.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Jason W.",
      location: "Gillette",
      rating: 5,
      text: "GCC grad heading to New Zealand for a working holiday. Needed a new passport and had never applied before. They made it simple — checklist, document review, fast processing. Got my passport and made my flight. Outstanding service.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "gillette-1",
      name: "Gillette Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "311 S Gillette Ave",
      city: "Gillette",
      state: "WY",
      zip: "82716",
      phone: "(307) 682-4843",
      hours: "Mon–Fri 9:00 AM – 3:30 PM (appointment required)",
      distance: "Downtown Gillette",
      website: "https://tools.usps.com/find-location.htm?location=1366040",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Campbell County. Appointment availability can be limited during energy sector shift changes — schedule at least a week in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "gillette-2",
      name: "Campbell County Clerk of District Court",
      type: "County Clerk Passport Acceptance",
      address: "500 S Gillette Ave, Suite 2600",
      city: "Gillette",
      state: "WY",
      zip: "82716",
      phone: "(307) 682-3424",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Downtown Gillette — Campbell County Courthouse",
      website: "https://www.ccgov.net/",
      websiteLabel: "Campbell County Website",
      notes: "Alternative to post office acceptance facilities. Appointment recommended. Does not offer photo services — bring your own passport photo.",
      icon: "ri-government-line",
    },
    {
      id: "gillette-3",
      name: "Wright Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 Wright Blvd",
      city: "Wright",
      state: "WY",
      zip: "82732",
      phone: "(307) 464-0342",
      hours: "Mon–Fri 8:30 AM – 4:00 PM (appointment required, limited hours)",
      distance: "Wright — about 40 miles south of Gillette",
      website: "https://tools.usps.com/find-location.htm?location=1381695",
      websiteLabel: "USPS Location",
      notes: "Serves southern Campbell County. Limited hours and appointment availability — call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "gillette-4",
      name: "Moorcroft Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 N Bighorn Ave",
      city: "Moorcroft",
      state: "WY",
      zip: "82721",
      phone: "(307) 756-3394",
      hours: "Mon–Fri 8:00 AM – 4:00 PM (appointment required)",
      distance: "Moorcroft — about 30 miles east of Gillette via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1369398",
      websiteLabel: "USPS Location",
      notes: "Serves eastern Campbell County and Crook County border area. Call ahead to confirm passport acceptance availability.",
      icon: "ri-mail-line",
    },
    {
      id: "gillette-5",
      name: "Sheridan Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 E Loucks St",
      city: "Sheridan",
      state: "WY",
      zip: "82801",
      phone: "(307) 672-0755",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Sheridan — about 100 miles northwest of Gillette via I-90",
      website: "https://tools.usps.com/find-location.htm?location=1373617",
      websiteLabel: "USPS Location",
      notes: "Alternative facility in northern Wyoming. About 1.5 hours from Gillette — useful when traveling through the region.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Denver Passport Agency, 380 miles and 6+ hour drive from Gillette one way", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Aurora, CO near Denver; 12+ hour round trip from Gillette", fpc: "Most Gillette travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — must prove travel date and emergency", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay, especially problematic from rural Wyoming", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Practicality for Gillette Residents", agency: "380-mile one-way drive to Denver — completely impractical for Campbell County", fpc: "Entirely remote — forms online, ship from Gillette, passport arrives at your door" },
    { feature: "Who Can Use It", agency: "Strict eligibility — life-or-death emergency only with proof of travel", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but factoring in travel to Denver, time off work, and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Campbell County Context", agency: "No Gillette-specific guidance — no Powder River Basin, GCC, or energy sector expertise", fpc: "Full Campbell County knowledge — energy sector, GCC, Powder River Basin travel patterns" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Short-Notice Energy Sector International Assignments",
      description: "Campbell County energy professionals often receive international assignment notices with 2-4 weeks lead time. An expired passport at that point means a frantic scramble. Check your passport expiration regularly — even when you are not planning travel.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for GCC Connection Timing",
      description: "GCC connects through Denver International Airport. Your passport is checked at Gillette check-in, not at DIA. A passport that will expire soon or is invalid will prevent you from boarding at GCC even if your international flight from Denver is days later.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Powder River Basin Address Verification Issues",
      description: "Rural Campbell County addresses and ranch mailing addresses (especially around Rozet, Recluse, and Weston) can differ from residential addresses on documentation. Mismatched addresses cause delays. We review all documentation to catch this.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Issues from Local Retailers",
      description: "Photos from Gillette pharmacies and retail stores may not meet strict State Department standards — particularly for lighting and background consistency. We catch these issues in review before they cause a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming Denver Is a Viable Option from Gillette",
      description: "At 380 miles each way, a Denver agency trip from Gillette requires 12+ hours of driving. Many Campbell County residents underestimate this distance and wait until the last minute. Our courier channel is the only practical expedited option in northeastern Wyoming.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether an energy conference, family vacation, or GCC study abroad program." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your situation — energy sector professional, ranch family, or GCC student." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Gillette clients ship from the UPS Store on Lakeway Road or the Gillette Post Office on Gillette Avenue." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our processing center. We submit through reserved agency slots — so Campbell County travelers never need to drive to Denver." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is completed within your selected timeframe and shipped directly to your Gillette, Wright, or Campbell County address. No agency visit. No Denver. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Gillette, Wyoming?", a: "We offer Gillette-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. The nearest regional passport agency is in Denver (380 miles away) — our remote courier service is the most practical fast option in Campbell County." },
    { q: "Do I need to visit a Gillette office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Gillette Post Office or Campbell County Clerk of Court), then ship documents overnight. We handle the State Department submission and return your passport to your Campbell County address." },
    { q: "Where can I get a passport acceptance near Gillette?", a: "Gillette has acceptance facilities at the Main Post Office on Gillette Avenue and the Campbell County Clerk of District Court. Nearby options include USPS locations in Wright and Moorcroft. We maintain an updated list of Campbell County-area facilities." },
    { q: "I work in the energy sector — can you handle short-notice passport needs?", a: "Yes. Campbell County energy professionals are among our most frequent clients. When international conferences, equipment training, or overseas assignments come up with 2-4 weeks notice, we provide fast expedited processing so you don't miss the opportunity. No Denver drive required." },
    { q: "What if I need a passport and Denver is too far?", a: "Denver Passport Agency is 380 miles from Gillette — a 6+ hour drive each way through Wyoming and Colorado. That's why our registered courier service is the best expedited option in Campbell County and the Powder River Basin. We handle the agency submission remotely." },
    { q: "What is the best price for expedited passport service in Gillette?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "What documents do Gillette applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Campbell County-specific checklist." },
    { q: "Can I get a passport photo in Gillette?", a: "Yes. The Gillette Post Office offers limited on-site passport photos. CVS, Walgreens, and the UPS Store on Lakeway Road also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How does GCC airport connect to international flights?", a: "Gillette Campbell County Airport (GCC) connects to Denver International Airport (DIA) via United Express. DIA offers direct international flights worldwide. Your passport must be valid when you check in at GCC, as you are ticketed through to your international destination." },
    { q: "Can you help with passports for GCC students studying abroad?", a: "Yes. Gillette College students heading abroad for study programs or transferring to four-year international programs need timely passport processing. We help GCC students navigate the process with clear checklists and fast expedited service." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Gillette Residents",
    intro: "Gillette's position in the Powder River Basin, along the I-90 corridor, and as the energy capital of Wyoming creates unique passport timing considerations. Here's what Campbell County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "GCC — Gillette Campbell County Airport",
        subtitle: "The essential first leg for Powder River Basin international travel",
        description: "GCC connects to Denver International Airport via United Express turboprop service. From DIA, travelers access direct flights to Europe, Asia, and Latin America. The critical insight: your passport is checked at GCC check-in, not at DIA. If your passport isn't valid, you won't board in Gillette.",
        tip: "Check your passport expiration when you book any itinerary departing from GCC — even if your international flight departs from Denver hours later. A passport problem at GCC check-in derails the entire trip.",
      },
      {
        icon: "ri-oil-line",
        title: "Energy Sector Rotations & International Assignments",
        subtitle: "Short-notice travel is the norm in Campbell County's energy economy",
        description: "Energy professionals in Gillette frequently receive international assignment notifications with 2-4 weeks notice — mining conferences in Australia, equipment training in Germany, project site visits in Indonesia, Middle East energy expos. This compressed timeline makes fast passport processing essential and makes the 380-mile Denver drive completely impractical.",
        tip: "Energy sector professionals should maintain passport validity as a standard practice — not just before planned trips. An unexpected international opportunity can surface in days, and passport processing can't wait.",
      },
      {
        icon: "ri-road-map-line",
        title: "I-90 Corridor & Northern Plains Travel",
        subtitle: "The northern transcontinental route shapes Gillette's travel options",
        description: "I-90 connects Gillette to Billings (200 miles northwest), Rapid City (140 miles east), and Sheridan (100 miles northwest). This corridor gives Gillette travelers access to multiple regional airports: GCC, BIL (Billings), RAP (Rapid City), and SHR (Sheridan). For international travel, Denver and Billings are the primary gateway airports.",
        tip: "Billings Logan International Airport (BIL) offers additional airline options beyond GCC connections and is 200 miles away. Consider BIL as an alternative departure point for international travel if GCC connections are fully booked.",
      },
      {
        icon: "ri-school-line",
        title: "GCC Students & International Opportunities",
        subtitle: "College students with study abroad and transfer programs",
        description: "Gillette College students participating in study abroad programs, transferring to four-year international universities, or pursuing working holiday visas need passport services aligned with academic deadlines. These transitions often have tight timelines between acceptance and departure.",
        tip: "GCC students should begin their passport application or renewal at least 3 months before any planned study abroad or international transfer start date. Summer programs require winter planning.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Gillette & the Powder River Basin",
      description: "Gillette is the economic heart of the Powder River Basin, one of the most productive coal mining and energy regions in the world. The city's rapid growth from a small railroad town to Wyoming's third-largest city mirrors the boom-and-bust cycles of the energy industry. Today, Gillette's energy professionals, ranch families, and GCC students form a community that is more internationally connected than its remote location on the high plains might suggest.",
    },
  },
  destinations: {
    title: "Where Gillette Travelers Go — And Why Passports Get Urgent",
    intro: "Gillette's identity as the Powder River Basin energy hub shapes its international travel patterns. Here are the most common destinations and urgency scenarios we see.",
    stats: [
      { stat: "45%", label: "of Gillette expedited requests involve energy sector international travel" },
      { stat: "2–4 Weeks", label: "average lead time for energy sector international assignments" },
      { stat: "May–Sep", label: "peak season for international conferences and family travel" },
      { stat: "380 Miles", label: "to nearest passport agency in Denver — our courier service bridges this" },
    ],
    destinations: [
      { name: "Middle East", context: "Energy conferences and expos in UAE, Saudi Arabia, Qatar; equipment supplier meetings; project site visits", urgency: "Conference invitations with 2–4 week lead time", icon: "ri-map-pin-2-line" },
      { name: "Australia & Southeast Asia", context: "Mining technology conferences in Perth and Brisbane, Indonesia project sites, equipment training in Singapore", urgency: "Training and project assignments with fixed start dates", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Canadian Rockies vacations, Calgary and Edmonton business connections, Saskatchewan energy sector collaboration", urgency: "Recreational and business travel with seasonal flexibility", icon: "ri-map-pin-2-line" },
      { name: "Europe", context: "Germany and UK mining equipment trade shows, family heritage travel, GCC study abroad programs", urgency: "Trade show dates and academic program deadlines", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "Chile and Peru mining sector conferences, Brazil energy expos, Argentina agricultural exchanges", urgency: "Conference and business travel with fixed dates", icon: "ri-map-pin-2-line" },
      { name: "New Zealand & Pacific", context: "Working holiday visas for GCC graduates, adventure travel, agricultural exchange programs", urgency: "Post-graduation travel with short turnaround", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Wyoming Service Areas",
    crossLinksDesc: "We serve travelers across the Equality State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Casper", route: "/casper" },
      { name: "Sheridan", route: "/sheridan-wy" },
      { name: "Rapid City, SD", route: "/rapid-city" },
    ],
  },
  photoLocations: [
    { name: "Gillette Main Post Office", address: "311 S Gillette Ave, Gillette, WY 82716", hours: "Mon–Fri 9 AM – 3:30 PM (limited photo service)", website: "https://tools.usps.com/find-location.htm" },
    { name: "The UPS Store — Gillette", address: "2610 S Douglas Hwy, Gillette, WY 82718", hours: "Mon–Fri 8:30 AM – 6:30 PM, Sat 10 AM – 3 PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart Supercenter — Gillette", address: "2300 S Douglas Hwy, Gillette, WY 82718", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Gillette", address: "503 W 2nd St, Gillette, WY 82716", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Gillette", address: "2610 S Douglas Hwy, Gillette, WY 82718", hours: "Daily 8 AM – 9 PM", website: "https://www.cvs.com/" },
    { name: "FedEx Office — Casper", address: "145 S Durbin St, Casper, WY 82601", hours: "Call for hours (100 miles from Gillette)", website: "https://www.office.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "Campbell County Treasurer — Motor Vehicle Division",
      address: "500 S Gillette Ave, Suite 1700, Gillette, WY 82716",
      hours: "Mon–Fri, 8:00 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "WyDOT Driver Services — Sheridan",
      address: "1949 Sugarland Dr, Sheridan, WY 82801",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Full driver services including testing and REAL ID. About 100 miles from Gillette.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "GCC",
      name: "Gillette Campbell County Airport",
      distance: "About 5 miles northeast of downtown Gillette (10 minutes via Highway 59)",
      address: "2000 Airport Rd, Gillette, WY 82716",
      note: "Connects to Denver International Airport via United Express. The primary departure point for most Gillette international travelers. Free parking.",
      flightUrl: "https://www.ccgov.net/271/Airport",
      flightLabel: "Gillette Airport",
      featured: true,
    },
    {
      code: "RAP",
      name: "Rapid City Regional Airport",
      distance: "About 140 miles east of Gillette (2 hours via I-90)",
      address: "4550 Terminal Rd, Rapid City, SD 57703",
      note: "Larger regional airport with connections to Denver, Minneapolis, Dallas, and Chicago. Alternative for Gillette travelers needing more flight options.",
      flightUrl: "https://www.rapairport.com/",
      flightLabel: "Rapid City Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Wyoming birth certificates from the Wyoming Department of Health Vital Statistics Services. Online, mail, or in-person options available.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through Wyoming Vital Statistics Services. Required for estate and legal matters in Campbell County.",
      url: "https://health.wyo.gov/admin/vitalstatistics/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Campbell County Clerk of District Court. Certified copies available for name changes and passport applications.",
      url: "https://www.ccgov.net/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Campbell County District Court. Required for name change passport corrections.",
      url: "https://www.ccgov.net/",
    },
  ],
};